/* eslint-disable */
const headers = document.querySelectorAll('.info-card__header.has-icon');
for (const header of headers) {
  header.addEventListener('click', () => header.parentElement.classList.toggle('is-open'));
}

document.addEventListener('DOMContentLoaded', () => {
  const commentForm = document.getElementById('commentform');

  if (commentForm) {
    commentForm.onsubmit = (event) => {
      const emailInput = document.getElementById('email');
      const emailValue = emailInput.value.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(emailValue)) {
        const errorMessage = document.createElement('span');
        errorMessage.className = 'email_validate_field';
        errorMessage.textContent = 'Por favor, insira um endereço de e-mail válido.';
        
        const existingErrorMessage = document.querySelector('.email_validate_field');
        if (existingErrorMessage) {
          existingErrorMessage.remove();
        }
        
        emailInput.insertAdjacentElement('afterend', errorMessage);
        emailInput.focus();
        event.preventDefault();
      }
    };
  }
});

